export default "__VITE_ASSET__fo70Lik4__"